export const StageDuration: Record<number | "DEFAULT", number> = {
  0: 23, // adjusted for treasure town theme
  1: 20,
  2: 20,
  3: 20,
  5: 40,
  8: 40,
  9: 40,
  10: 50,
  11: 40,
  15: 40,
  19: 40,
  20: 50,
  DEFAULT: 30
}
export const FIGHTING_PHASE_DURATION = 45000
export const ITEM_CAROUSEL_BASE_DURATION = 16000
export const PORTAL_CAROUSEL_BASE_DURATION = 23000

export const ItemCarouselStages = [4, 12, 17, 22, 27, 34]
export const AdditionalPicksStages = [5, 8, 11]
export const PortalCarouselStages = [0, 10, 20]
export const GiftShopStages = [16, 18, 21, 23]
